module.exports = __webpack_public_path__ + "fonts/31ab0661e673f315e8ba20313c1432cc.svg";